import React from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
  dateTimeToserver,
} from "lib/helpers";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { TextArea } from "components/form";
import cleanObject from "utils/editHelper";
import { GalleryField } from "components/form";
import MultySearchSelect from "utils/MultySearchSelect";
import SearchSelect from "utils/SearchSelect";
import extractValues from "utils/extractValues";
import initItem from "utils/initItem";
import AchievementComponent from "utils/AchievementComponent";
import SocialComponent from "utils/SocialComponent";
import MetaDataComponent from "utils/MetaDataComponent";
// components

const ROLES = [
  { label: "مدیر", value: "admin" },
  { label: "نویسنده", value: "author" },
  { label: "کاربر", value: "user" },
];

export default function Edit(props) {
  const core = useCore();
  const { show, item } = props;

  const config = {
    team: {
      valueField: "id",
      labelFields: ["translations.fa.name"],
    },
    previousTeams: {
      valueField: "id",
      labelFields: ["translations.fa.name"],
    },
  };
  const updatedItem = initItem(item, config);

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={updatedItem}
          onSubmit={async (values, { setSubmitting }) => {
            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");

            const clean = cleanObject(values, [
              "id",
              "uuid",
              "updatedAt",
              "createdAt",
              "news",
              "videos",
              "statistics",
            ]);
            const result = extractValues(clean, ["team", "previousTeams"]);

            await props.submit(result, item.id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values, setFieldValue }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام"
                    label="نام :"
                    name="translations.fa.name"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام(en)"
                    label="نام (en):"
                    name="translations.en.name"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام خانوادگی"
                    label="نام خانوادگی :"
                    name="translations.fa.lastName"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام خانوادگی(en)"
                    label="نام خانوادگی(en) :"
                    name="translations.en.lastName"
                    component={TextField}
                  />

                  <Field
                    placeholder="ملیت"
                    label="ملیت :"
                    name="translations.fa.nationality"
                    component={TextField}
                  />
                  <Field
                    placeholder="ملیت(en)"
                    label="ملیت(en) :"
                    name="translations.en.nationality"
                    component={TextField}
                  />

                  <Field
                    placeholder="مدرک"
                    label="مدرک :"
                    name="translations.fa.certification"
                    component={TextField}
                  />
                  <Field
                    placeholder="مدرک(en)"
                    label="مدرک(en) :"
                    name="translations.en.certification"
                    component={TextField}
                  />

                  <Field
                    placeholder="نقش در تیم"
                    label="تقش در تیم :"
                    name="translations.fa.role"
                    component={TextField}
                    // validate={isUserName}
                  />
                  <Field
                    placeholder="نقش در تیم (en)"
                    label="تقش در تیم (en) :"
                    name="translations.en.role"
                    component={TextField}
                    // validate={isUserName}
                  />

                  <div className="user-datepicker">
                    <Field
                      label="تاریخ تولد :"
                      name="birthDate"
                      component={PersianDataPicker}
                    />
                  </div>
                  <Field
                    label="وضعیت :"
                    name="isActive"
                    component={Select}
                    options={[
                      { value: true, label: "فعال" },
                      { value: false, label: "غیر فعال" },
                    ]}
                    className="w-full px-3 py-2 border rounded"
                  />

                  <Field
                    label="تیم فعلی :"
                    name="team"
                    component={SearchSelect}
                    searchFields="translations.name"
                    collectionName="team"
                    showFields="translations.name"
                    className="w-full px-3 py-2 border rounded"
                  />

                  <Field
                    label="تیم های قبلی:"
                    name="previousTeams"
                    component={MultySearchSelect}
                    searchFields="translations.name"
                    collectionName="team"
                    showFields="translations.name"
                    className="w-full px-3 py-2 border rounded"
                  />
                </div>
                <div className="w-full flex justify-between">
                  <div className="w-full">
                    <Field
                      label="تصویر"
                      name="profileImage"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>

                <AchievementComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="Coach"
                />
                <SocialComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="Coach"
                />
                <MetaDataComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="Coach"
                />
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
